import { createContext } from 'react';
import { IChartContext } from 'look-back/interfaces';

export const DonutChartContext = createContext<IChartContext>(undefined!);
